import React, { useState, useEffect, useCallback, useLayoutEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import client from '../modules/axios';
import Destinations from '../layout/Destinations';
import { API } from '../config/path';
import { useApp } from '../context/appContext';
import { Helmet } from 'react-helmet-async';

const initPageSettings = {
  page: 1,
  search: null,
  category: null,
  region: null,
  totalPage: 0,
};

const App = () => {
  const { snackbar, setSnackbar } = useApp();
  const [searchParams] = useSearchParams();
  const [products, setProducts] = useState(null);
  const [pageSettings, setPageSettings] = useState(initPageSettings);
  const [isSearch, setIsSearch] = useState(false);
  const [isGetProducts, setIsGetProducts] = useState(true);
  const [meta, setMeta] = useState(null);

  const getMeta = useCallback(() => {
    client
      .get(API.SEO_PAGE + '?page_name=destination')
      .then((response) => {
        const data = response.data.data;

        setMeta(data);
      })
      .catch((_error) => {
        // Snackbar.error(error.statusText);
      });
  }, []);

  useLayoutEffect(() => {
    getMeta();
  }, [getMeta]);

  const slug = useParams().slug ?? null;

  console.log(slug, 'slug');

  useEffect(() => {
    if (searchParams.has('search')) {
      setPageSettings({
        ...pageSettings,
        search: searchParams.get('search'),
      });
    }

    if (searchParams.has('region')) {
      setPageSettings({
        ...pageSettings,
        region: searchParams.get('region'),
      });
    }
    
    setIsSearch(true);
  }, [searchParams.has('search'), searchParams.has('region')]);

  // const getProducts = useCallback(() => {
  //   client
  //     .get(
  //       `${API.PRODUCTS}?${
  //         `page=${pageSettings.page}` +
  //         (pageSettings.category !== null ? `&c=${pageSettings.category}` : '') +
  //         (pageSettings.search !== null ? `&t=${pageSettings.search}` : '') +
  //         (pageSettings.region !== null ? `&r=${pageSettings.region}` : '')
  //       }`,
  //     )
  //     .then((res) => {
  //       if (res.data.error) {
  //         setProducts([]);
  //         setPageSettings({
  //           ...pageSettings,
  //           totalPage: 1,
  //         });

  //         return;
  //       }

  //       const data = res.data.data;

  //       setProducts(data);
  //       setPageSettings((prev) => ({
  //         ...prev,
  //         totalPage: res.data.total_page,
  //       }));
  //     })
  //     .catch((err) => {
  //       console.log('err', err);
  //       setSnackbar({
  //         ...snackbar,
  //         open: true,
  //         message: 'Something went wrong',
  //         type: 'error',
  //       });
  //     })
  //     .finally(() => {
  //       setIsGetProducts(false);
  //     });
  // }, [pageSettings.search, pageSettings.category, pageSettings.region, pageSettings.page]);


    const getProducts = (payload)=>{
        client
      .get(
        `${API.PRODUCTS}?${
          `page=${payload?.page ||1}` +
          (payload?.category !== null ? `&c=${payload?.category}` : '') +
          (payload?.search !== null ? `&t=${payload?.search}` : '') +
          // (payload?.region !== null ? `&r=${payload?.region}` : '')
          (slug !== null ? `&s=${slug}` : '')
        }`,
      )
      .then((res) => {
        if (res.data.error) {
          setProducts([]);
          setPageSettings({
            ...payload,
            totalPage: 1,
          });

          return;
        }

        const data = res.data.data;

        setProducts(data);
        setPageSettings((prev) => ({
          ...prev,
          totalPage: res.data.total_page,
        }));
      })
      .catch((err) => {
        console.log('err', err);
        setSnackbar({
          ...snackbar,
          open: true,
          message: 'Something went wrong',
          type: 'error',
        });
      })
      .finally(() => {
        setIsGetProducts(false);
      });
    }

  // useEffect(() => {
  //   getProducts();
  //   window.scrollTo(0, 0);
  // }, [pageSettings.page]);

  useEffect(() => {
    if (isSearch) {
      setPageSettings({
        ...pageSettings,
        page: 1,
      });
      getProducts({...pageSettings,page:1});
      setIsSearch(false);
    }
  }, [isSearch, getProducts]);

  console.log(isSearch, 'isSearch');

  return (
    <>
      {meta && (
        <Helmet>
          <title>{meta.title ?? 'Indoaddict'}</title>
          <meta name="keyword" content={meta.keyword} />
          <meta name="description" content={meta.description} />

          {meta?.type.map((item, i) => {
            if (meta.value === 'title') {
              return <title key={i}>{item.content}</title>;
            }

            if (item.value === 'canonical') {
              return <link key={i} rel="canonical" href={item.content} />;
            }

            return <meta key={i} {...{ [item.tag_type]: item.value }} content={item.content} />;
          })}
        </Helmet>
      )}

      <Destinations
        products={products}
        pageSettings={pageSettings}
        setPageSettings={(e)=>{
          getProducts(e)
          setPageSettings(e)
          window.scrollTo(0, 0);
        }}
        setIsSearch={setIsSearch}
        isGetProducts={isGetProducts}
      />
    </>
  );
};

export default App;
